/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Bold_Lion_RoarInputs */

const en_crisp_bold_lion_roar = /** @type {(inputs: Crisp_Bold_Lion_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating PowerPoint…`)
};

const de_crisp_bold_lion_roar = /** @type {(inputs: Crisp_Bold_Lion_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PowerPoint wird erstellt…`)
};

/**
* | output |
* | --- |
* | "Generating PowerPoint…" |
*
* @param {Crisp_Bold_Lion_RoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_bold_lion_roar = /** @type {((inputs?: Crisp_Bold_Lion_RoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Bold_Lion_RoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_bold_lion_roar(inputs)
	return de_crisp_bold_lion_roar(inputs)
});